import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { reducePolicyTestOverride } from '../../actions/policy/reducePolicyTestOverride';
import { selectEntity } from '../../selectors/policy/selectEntity';
import { getPolicySaga } from './getPolicySaga';

export function* setPolicyTestOverrideSaga(action) {
    try {
        yield put(reduceLoading({ code: 'setPolicyTestOverride', value: true }));
        const session = yield getSessionSaga();
        const entity = yield select(selectEntity());

        const payload = {
            data: {
                policyTransactionGuid: entity,
                isPolicyInTestMode: action.payload.isPolicyInTestMode,
                goFirmDateTest: action.payload.goFirmDateTest,
            },
        };

        const response = yield call(fetch, '/api/smoPolicyTestOverride', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        const result = yield call([response, 'json']);
        yield put(reduceOperation(result.operation));

        if (!result.operation.status) {
            yield put(reduceLoading({ code: 'setPolicyTestOverride', value: false }));
            return;
        }

        yield put(reducePolicyTestOverride(result.data));

        // Reload policy data so other forms have updated CustomInfo
        // This prevents stale CustomInfo from overwriting GoFirmDateTest
        yield call(getPolicySaga);

        yield put(reduceLoading({ code: 'setPolicyTestOverride', value: false }));

        // Reload page to ensure all components reflect updated test mode settings
        window.location.reload();
    } catch (error) {
        console.log('Error while calling Set PolicyTestOverride API - ', error);
        yield put(reduceLoading({ code: 'setPolicyTestOverride', value: false }));
    }
}
